import { __rest } from "tslib";
import * as React from 'react';
import RcImage from 'rc-image';
import RotateLeftOutlined from '@haier/icons/RotateLeftOutlined';
import RotateRightOutlined from '@haier/icons/RotateRightOutlined';
import ZoomInOutlined from '@haier/icons/ZoomInOutlined';
import ZoomOutOutlined from '@haier/icons/ZoomOutOutlined';
import CloseOutlined from '@haier/icons/CloseOutlined';
import LeftOutlined from '@haier/icons/LeftOutlined';
import RightOutlined from '@haier/icons/RightOutlined';
import { ConfigContext } from '../config-provider';
import { getTransitionName } from '../_util/motion';
export const icons = {
    rotateLeft: React.createElement(RotateLeftOutlined, null),
    rotateRight: React.createElement(RotateRightOutlined, null),
    zoomIn: React.createElement(ZoomInOutlined, null),
    zoomOut: React.createElement(ZoomOutOutlined, null),
    close: React.createElement(CloseOutlined, null),
    left: React.createElement(LeftOutlined, null),
    right: React.createElement(RightOutlined, null),
};
const InternalPreviewGroup = (_a) => {
    var { previewPrefixCls: customizePrefixCls, preview } = _a, props = __rest(_a, ["previewPrefixCls", "preview"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('image-preview', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedPreview = React.useMemo(() => {
        if (preview === false) {
            return preview;
        }
        const _preview = typeof preview === 'object' ? preview : {};
        return Object.assign(Object.assign({}, _preview), { transitionName: getTransitionName(rootPrefixCls, 'zoom', _preview.transitionName), maskTransitionName: getTransitionName(rootPrefixCls, 'fade', _preview.maskTransitionName) });
    }, [preview]);
    return (React.createElement(RcImage.PreviewGroup, Object.assign({ preview: mergedPreview, previewPrefixCls: prefixCls, icons: icons }, props)));
};
export default InternalPreviewGroup;
